import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';

import { commonStyles } from '../../../styles/styles';

import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import NumberField from '../NumberField';



const ForthPage = ({ classes, form, pristine, previousPage, submitting, ...props, drop }) => {
  const { handleSubmit, dropdowns } = props;
  return (
    <form onSubmit={handleSubmit} className="w-100">
    <MDBCol className="w-100"  md="12">
    <MDBRow>
      <MDBCol md="6">
      <Field name="conSocioEconomicStatus" label="Socio-Economic Status" component={Dropdown}  options={dropdowns.dropdowns.socioEconomics}/>
      </MDBCol>
      <MDBCol md="6">
      <Field name="disability" label="Disability Status" component={Dropdown}  options={dropdowns.dropdowns.disabilities}/>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      <Field name="highestQualification" label="Highest Qualification" component={Dropdown}  options={dropdowns.dropdowns.highestQualification}/>
    
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      <Field name="highestSchoolLevel" label="Highest School Level" component={Dropdown}  options={dropdowns.dropdowns.highestSchoolLevel}/>
     
      </MDBCol>
      <MDBCol md="6">
       <Field name="driversLicence" label="Drivers License" component={Dropdown}  options={dropdowns.dropdowns.driversLicense}/>
      </MDBCol>
      
    </MDBRow>
    <MDBRow>
    <MDBCol md="12">
      <Field name="qualificationDetail" label="Qualification Detail (Optional)" component={TextField}  />
     
      </MDBCol>
    </MDBRow>
    <MDBRow>
     
      <MDBCol md="12">
      <Field name="socc" label="Standard Occupational Category Code" component={Dropdown}  options={dropdowns.dropdowns.socc}/>
      </MDBCol>
    </MDBRow>

    <MDBRow>
      <MDBCol md="6">
      <Field name="positionHeld" label="Position Held (Optional)" component={TextField}  />
     
      </MDBCol>
      <MDBCol md="6">
      <Field name="businessUnit" label="Business Unit (Optional)" component={TextField}  />
      </MDBCol>
      
    </MDBRow>

    <MDBRow>
     
     <MDBCol md="12">
     <Field name="noYears" label="No. of years Employed (Optional)" component={NumberField}  />
     </MDBCol>
   </MDBRow>
   
   <MDBRow className="mt-2">
            <MDBCol size="6">
              <MDBBtn 
                  right
                  size="md"
                  className='mt-0 mb-2 float-left danger-color-dark'
                  action
                  onClick={previousPage}
                  type="button">
                PREVIOUS
              </MDBBtn>
            </MDBCol>
            <MDBCol size="6">
              <MDBBtn color="success"
                  right
                  size="md"
                  className='ml-3 mr-2 mt-0 mb-2 float-right'
                  action
                  type="submit">
                NEXT
              </MDBBtn>
            </MDBCol>
          </MDBRow>

  </MDBCol>
  </form>
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}>Page 3 of 5</h4>
    //   <form onSubmit={handleSubmit}>
  
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="conSocioEconomicStatus" label="Socio-Economic Status" component={Dropdown}  options={dropdowns.dropdowns.socioEconomics}/>
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="disability" label="Disability Status" component={Dropdown}  options={dropdowns.dropdowns.disabilities}/>
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="highestQualification" label="Highest Qualification" component={Dropdown}  options={dropdowns.dropdowns.highestQualification}/>
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="highestSchoolLevel" label="Highest School Level" component={Dropdown}  options={dropdowns.dropdowns.highestSchoolLevel}/>
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //     <Field name="qualificationDetail" label="Qualification Detail (Optional)" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="driversLicence" label="Drivers License" component={Dropdown}  options={dropdowns.dropdowns.driversLicense}/>
    //     </div>
    //     <div className={`${classes.fullField} ${classes.firstInRow}`}>
    //       <Field name="socc" label="Standard Occupational Category Code" component={Dropdown}  options={dropdowns.dropdowns.socc}/>
    //     </div>
    //     <div>
    //       <div className={`${classes.halfField}`} styles="justifyContent: 'right', display: 'inline-flex'">
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="button"  onClick={previousPage}>Previous</button>
    //       </div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="submit" >Next</button>
    //       </div>
    //     </div>
    //   </form>
    // </div>
  ) 
}



ForthPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
 
  withStyles(styles),
)(ForthPage);



// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationSteps/ForthPage.jsx